import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/tick.svg";
var TickSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  TickSolid_default as default
};
